interface SubQuestionStyles {
  styles: { readonly [key: string]: string };
  isSubQuestion: boolean;
}

const subQuestionStyles = ({ styles, isSubQuestion }: SubQuestionStyles): string =>
  isSubQuestion ? styles.subQuestion : '';

export { subQuestionStyles };
